import { render, staticRenderFns } from "./BannerContainer.vue?vue&type=template&id=83f67ab6&scoped=true&"
import script from "./BannerContainer.vue?vue&type=script&lang=js&"
export * from "./BannerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f67ab6",
  null
  
)

export default component.exports